<div class="close-icon handPointer" [innerHTML]="ICONS.closeCircleIcon | safeHtml" (click)="onClose()"></div>
<div class="modal-body">
  <p>Access to detailed {{ entity }} information is restricted to registered users. Please register or log in to continue.</p>
</div>
<div class="modal-footer">
  <ul>
    <li>
      <button class="common--button_unfill" (click)="closeModalAndNavigate('/auth/login')">Login</button>
    </li>
    <li>
      <button class="common--button_unfill" (click)="closeModalAndNavigate('/auth/signup')">Register</button>
    </li>
  </ul>
</div>
